import Marquee from "react-fast-marquee";

const words = ["Residential", "Commercial", "Vacation Rentals", "Deep Cleans", "Move-outs", "Turnovers"];

export default function MarqueeStrip() {
  return (
    <section className="py-16 md:py-24 overflow-hidden" data-testid="marquee-section" aria-hidden="true">
      <Marquee speed={45} gradient={false} autoFill>
        {words.map((w, i) => (
          <span key={i} className="mx-8 flex items-center gap-8">
            <span className="font-serif text-6xl md:text-8xl italic marquee-outline">{w}</span>
            <span className="text-[#C1440E] text-3xl md:text-5xl">✦</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
}
